export default __webpack_public_path__ + "static/Lutein-Complex-home-@3x-60d68d6016e320e6e7c543b672432ee5.jpg";